var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4818 17.0413C20.1727 17.733 20.1727 18.8088 19.4818 19.5005C19.1363 19.8463 18.714 20 18.2534 20C17.7927 20 17.3704 19.8463 17.025 19.5005L10 12.4688L2.97505 19.5005C2.62956 19.8463 2.20729 20 1.74664 20C1.28599 20 0.863724 19.8463 0.518234 19.5005C-0.172745 18.8088 -0.172745 17.733 0.518234 17.0413L7.54319 10.0096L0.518234 2.97791C-0.172745 2.28626 -0.172745 1.21037 0.518234 0.518732C1.20921 -0.172911 2.28407 -0.172911 2.97505 0.518732L10 7.55043L17.025 0.518732C17.7159 -0.172911 18.7908 -0.172911 19.4818 0.518732C20.1727 1.21037 20.1727 2.28626 19.4818 2.97791L12.4568 10.0096L19.4818 17.0413Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6be63b038fb864f2744412e05450d05e.svg";
export { ForwardRef as ReactComponent };